import { normalizeRole, ROLES } from '../../shared/constants/roles';

export const CONTROLLER_FULL_DETAIL_ROLES = Object.freeze([ROLES.SUPER_ADMIN, ROLES.DEVELOPER]);

export const canViewControllerFullDetail = (role) => {
  return CONTROLLER_FULL_DETAIL_ROLES.includes(normalizeRole(role));
};

export const resolveControllerDetailPath = (role, controllerId, fallback = '/controllers') => {
  if (!controllerId || !canViewControllerFullDetail(role)) {
    return fallback;
  }

  return `/controllers/${encodeURIComponent(controllerId)}`;
};
